import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrgService } from 'app/org/org.service';
import { RegexpMatchers } from 'app/shared/model/regexp-matches.model';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  selector: 'cc-add-team',
  templateUrl: '../edit-folder.component.html',
  styleUrls: ['add-team.component.scss'],
})
export class AddTeamComponent {
  title: string;
  projectId: string;
  loading: boolean;
  model = { id: '', name: '' };
  readonly doNotAcceptWithoutAlphanumeric = RegexpMatchers.doNotAcceptWithoutAlphanumeric;

  constructor(
    private readonly orgService: OrgService,
    public readonly modal: NgbActiveModal,
    private readonly toastrService: ToastrService,
    private readonly errorHandler: ErrorHandler,
  ) {}

  onSubmit() {
    this.loading = true;
    this.orgService.addTeam(this.projectId, this.model.name.trim()).subscribe(
      (team) => {
        this.toastrService.successByKey('teamAdded');
        team.isNew = true;
        this.modal.close(team);
      },
      (error) => {
        this.errorHandler.handle(error);
        this.loading = false;
      },
    );
  }
}
